import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const TrainerToolsIcon = (props: SvgIconProps) => (
  <SvgIcon
    width="28"
    height="28"
    viewBox="0 0 28 28"
    sx={{ fill: 'none' }}
    {...props}
  >
    <path
      d="M14 16.6443V26.4349C14 26.6469 14.3965 26.7861 14.5571 26.6476C16.1319 25.2883 20.2006 23.6668 21.7 23.36C23.1 23.0735 23.1 21.5691 23.1 20.4945V16.1966C23.1 14.9433 23.2583 13.0307 21.35 13.3314C17.7925 13.8919 15.0595 15.6376 14.0662 16.4966C14.0232 16.5338 14 16.5874 14 16.6443Z"
      stroke="white"
      strokeWidth="1.5"
    />
    <path
      d="M14 16.6442V26.4346C14 26.6467 13.6033 26.7859 13.4428 26.6473C11.8683 25.2881 7.8015 23.6668 6.30274 23.36C4.90323 23.0735 4.90323 21.5691 4.90323 20.4945V16.1966C4.90323 14.9433 4.74494 13.0307 6.65261 13.3314C10.2089 13.8919 12.9408 15.6376 13.9338 16.4966C13.9768 16.5338 14 16.5874 14 16.6442Z"
      stroke="white"
      strokeWidth="1.5"
    />
    <path
      d="M13.9996 11.9001C16.7058 11.9001 18.8996 9.70629 18.8996 7.0001C18.8996 4.2939 16.7058 2.1001 13.9996 2.1001C11.2934 2.1001 9.09961 4.2939 9.09961 7.0001C9.09961 9.70629 11.2934 11.9001 13.9996 11.9001Z"
      stroke="white"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M19.9497 13.6168C19.6877 13.4516 19.4184 13.297 19.1424 13.1536C17.5568 12.3299 15.7963 11.8999 14.0095 11.8999C12.2228 11.8999 10.4622 12.3299 8.87667 13.1536C8.66369 13.2643 8.45471 13.3816 8.25 13.5053"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
